angular.module('clientDashboardApp').directive('showHideMismatch', () => {
  return {
    restrict: 'E',
    scope: {
      setting: '='
    },
    template: `
    <a
      ng-if="setting.isIgnored || setting.hasMismatch"
      requires-permission="EditLocation"
      class="fas ss plain"
      ng-class="{
        'ss-loading fa-spin': setting.updating,
         'ss-view': setting.isIgnored && !setting.updating,
         'ss-ban': !setting.isIgnored && !setting.updating,
         'text-muted': setting.updating || setting.isIgnored,
         'text-danger': !setting.updating && !setting.isIgnored
        }"
      uib-tooltip="{{setting.isIgnored ? 'Show ' + setting.name + ' Mismatch' : 'Ignore ' + setting.name + ' Mismatch'}}"
      ng-click="setting.onClick()"
    ></a>`
  }
})
